import React from 'react';
import { css } from '@emotion/css';
import { Msg, useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  overviewHeadline: css`
    font-size: 18px;
    line-height: 22px;
    padding-bottom: 18px;
  `,
  overviewParagraph: css`
    font-size: 16px;
    line-height: 22px;
    padding-bottom: 18px;
    &:nth-child(3) {
      padding-bottom: 27px;
    }
  `,
};
const ProductDescription: React.FC = () => {
  const { t } = useIntl();

  return (
    <>
      <p className={styles.overviewHeadline}>
        {t({
          id: 'benefits.deposit.modal.overview.productDescription.overviewHeadline',
          defaultMessage: 'Komm du erstmal an - die Kaution ist schon da.',
        })}
      </p>
      <p className={styles.overviewParagraph}>
        {t({
          id: 'benefits.deposit.modal.overview.productDescription.overviewParagraph1',
          defaultMessage:
            'Eine Mietkautionsbürgschaft ist eine Alternative zu der klassischen Barkaution. Übergebe deinem:deiner Vermieter:in die Bürgschaftsurkunde der Allianz (max. Kautionssumme 5.000€), statt bis zu drei Monatsmieten Kaution zu zahlen.',
        })}
      </p>
      <p className={styles.overviewParagraph}>
        {t({
          id: 'benefits.deposit.modal.overview.productDescription.overviewParagraph2',
          defaultMessage: 'Bei bereits gezahlter Kaution erhältst du ggf. von Vermieter:innen deine Barkaution zurück.',
        })}
      </p>
      <ul className='list-check list-spacing-s'>
        <li>
          {t({
            id: 'benefits.deposit.modal.overview.productDescription.checkmark1',
            defaultMessage: 'Keine Barkaution zahlen',
          })}
        </li>
        <li>
          {t({
            id: 'benefits.deposit.modal.overview.productDescription.checkmark2',
            defaultMessage: 'Als kurz- oder langfristige Lösung',
          })}
        </li>
        <li>
          {t({
            id: 'benefits.deposit.modal.overview.productDescription.checkmark3',
            defaultMessage: 'Keine Mindestvertragslaufzeit, keine Kündigungsfrist',
          })}
        </li>
        <li>
          <Msg
            id='benefits.deposit.modal.overview.productDescription.checkmark4'
            defaultMessage='In {badgeLabel} enthalten'
            values={{ badgeLabel: <PlusBadge variant='rent' /> }}
          />
        </li>
      </ul>
    </>
  );
};

export default ProductDescription;
